'use client'

import { SmallMediaCard } from '@news12/storybook-news'

import React, { useCallback } from 'react'

import { trackGTMEvent } from '../../config/analytics'
import { StoryPreview } from '../../types'
import { getFormattedRelativeTime } from '../../utils/date'
import { getDuration } from '../../utils/duration'

export type MoreStoriesCardProps = StoryPreview & {
  orderNumber: number
}

const MoreStoriesCard = ({
  durationTime,
  title,
  thumbnail,
  href,
  updatedAt = '',
  orderNumber
}: MoreStoriesCardProps) => {
  const handleSmallMediaCardClick = useCallback(() => {
    trackGTMEvent.gaMoreStoriesMediaCardClick(orderNumber, title)
  }, [orderNumber, title])

  return (
    <SmallMediaCard
      durationTime={getDuration(durationTime)}
      thumbnail={{ src: thumbnail, alt: title }}
      heading={title}
      href={href}
      updatedAt={getFormattedRelativeTime(updatedAt)}
      onClick={handleSmallMediaCardClick}
    />
  )
}

export default MoreStoriesCard
